import React, { ReactNode } from 'react'
import { useInfo } from '../context/useInfo'
import { Link, useLocation } from 'react-router'

interface ErrorBaseProps {
    errorCode: number
    errorDescription: ReactNode
    className?: string
    src: string
}

function ErrorBase({errorCode = 200, errorDescription, className = "", src}: ErrorBaseProps) {
    const infoContext = useInfo()
    const location = useLocation()

    function logoutButton(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        event.preventDefault()
        if (infoContext) infoContext.logout()
    }

    return <section className='pt-20 flex flex-row-reverse flex-wrap justify-center gap-4 px-4'>
        <img src={src} draggable={false} alt="Error icon" className='w-52 aspect-square h-52' />
        <div className='max-w-56'>
            <h2 className={'font-bold text-8xl '+ className}>{String(errorCode)}</h2>
            <span className='text-xl'>{errorDescription}</span>
            {infoContext && infoContext.info && <Link to={`/logout?location=${location.pathname}`} onClick={logoutButton} className='pt-2 text-primary font-bold block'>Log out</Link>}
        </div>
    </section>
}

export default ErrorBase